import React, { Component, Dispatch } from 'react';
import { FormikContext } from 'formik';
import Input from '../../../../components/input/text/input-formik';
import { DatetimeFormik } from '../../../../components/input/date-time/date-time-formik';
import { Quil } from '../../../../components/input/quil/main';
import { SelectAsync, SelectNoneAsync } from '../../../../components/input/select/main';
import { ActivityCompletionType } from '../../../../models/enums/activityCompletionType';
import { FileUpload } from '../../../../components/file-upload/main';
import { Log } from 'ng2-logger';
import Translator from '../../../../core/i18n';
import { Confirm } from '../../../../components/notification/main';
import Switch from 'react-switch';
import { Common } from '../../../../core/common';
import { ExamScoringType } from '../../../../models/enums/ExamScoringType';
import { ExamQuestionWeightingType } from '../../../../models/enums/ExamQuestionWeightingType';
import { QuestionWeight } from './questionWeight';
import { ActivityTiming } from '../../../../components/add-activity/timing';
import { IExamSessionProps } from '../../../../models/components/add-activity-exam-sessions';
import CSessionDetail from './sessionDetail';
import CSessionList from './sessionList';
import CAddExamSession from './add-session-modal/main';
import * as Actions from '../../../../store/actions/examSession';
import { IAction, IAppState } from '../../../../models/action/core';
import { connect } from 'react-redux';

const T = Translator.create();
const _logger = Log.create('Exam Add Page Session');
let _common: Common;

interface IAddExamSessionState {
    addExamSessionIsOpen: boolean;
    selectedExamSessionId: string;
    currentTab: string;
}

export class Session extends Component<IExamSessionProps, IAddExamSessionState> {
    constructor(props: any) {
        super(props);
        _common = new Common();

        this.state = {
            addExamSessionIsOpen: false,
            selectedExamSessionId: '',
            currentTab: '_sessionProperties'
        };
    }

    triggerModal = (examSessionId: string, currentTab: string) => {
        this.setState({
            addExamSessionIsOpen: !this.state.addExamSessionIsOpen,
            selectedExamSessionId: examSessionId,
            currentTab
        });
    };

    setExamSessionId = (examSessionId: string) => {
        this.setState({
            selectedExamSessionId: examSessionId
        });
    }

    public render() {
        return (
            <div
                className={'tab-pane fade' + (this.props.currentTab === '_sessionTab' ? ' show active' : '')}
                style={{ display: this.props.currentTab === '_sessionTab' ? 'block' : 'none' }}
                id="session"
                role="tabpanel"
                aria-labelledby="session-tab"
            >
                <div className="content-container announcement session_tab_content" style={{backgroundColor:'#fbfaf6'}}>
                    <CSessionList 
                        triggerModal={this.triggerModal} 
                        updateActivityId={this.props.updateActivityId}
                    />
                    <CSessionDetail triggerModal={this.triggerModal} />
                    <CAddExamSession
                        isModalOpen={this.state.addExamSessionIsOpen}
                        examSessionId={this.state.selectedExamSessionId}
                        setCloseModal={this.triggerModal}
                        updateActivityId={this.props.updateActivityId}
                        formik={this.props.formik}
                        setExamSessionId={this.setExamSessionId}
                        currentTab={this.state.currentTab}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IExamSessionProps): IExamSessionProps => {
    if (!state) {
        return ownProps;
    }

    const newProps: IExamSessionProps = Object.assign({}, ownProps, {
        coursePageActivityId: state.coursePage.coursePageActivityId,
        coursePageClassId: state.coursePage.coursePageClassId,
    });

    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret =
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CSession = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(Session);

export default CSession;
